import { render, staticRenderFns } from "./codes-dictionary.vue?vue&type=template&id=1246915d&scoped=true&"
import script from "./codes-dictionary.vue?vue&type=script&lang=js&"
export * from "./codes-dictionary.vue?vue&type=script&lang=js&"
import style0 from "./codes-dictionary.vue?vue&type=style&index=0&id=1246915d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1246915d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1246915d')) {
      api.createRecord('1246915d', component.options)
    } else {
      api.reload('1246915d', component.options)
    }
    module.hot.accept("./codes-dictionary.vue?vue&type=template&id=1246915d&scoped=true&", function () {
      api.rerender('1246915d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/charts/timesheets/chart/components/codes-dictionary.vue"
export default component.exports